import { useBlocker } from '@tanstack/react-router';
import { Modal } from 'antd';
import { useEffect } from 'react';

export const useUnsavedChangesGuard = (isDirty: boolean | (() => boolean)) => {
  const checkDirty = () => (typeof isDirty === 'function' ? isDirty() : isDirty);
  const { status, proceed, reset } = useBlocker({
    shouldBlockFn: ({ current, next }) => current.routeId !== next.routeId && checkDirty(),
    enableBeforeUnload: checkDirty,
    withResolver: true,
  });

  useEffect(() => {
    if (status !== 'blocked') {
      return;
    }

    Modal.confirm({
      title: 'Leave without saving?',
      content: 'You have unsaved changes. If you leave this page now, they will be lost.',
      okText: 'Leave',
      okButtonProps: { danger: true, 'data-testid': 'confirm' },
      cancelText: 'Stay',
      cancelButtonProps: { 'data-testid': 'cancel' },
      onOk: proceed,
      onCancel: reset,
    });
  }, [status, proceed, reset]);
};
